module.exports = __webpack_public_path__ + "static/media/support_agent.dc35fdc5.svg";